import { render, staticRenderFns } from "./newJobLogs.vue?vue&type=template&id=d5054a50&scoped=true"
import script from "./newJobLogs.vue?vue&type=script&lang=js"
export * from "./newJobLogs.vue?vue&type=script&lang=js"
import style0 from "./newJobLogs.vue?vue&type=style&index=0&id=d5054a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5054a50",
  null
  
)

export default component.exports